import Vue from 'vue';

const repository = Vue.observable({
  type: '2',
  package_id: '',
  name: '',
  attachment: '13',
});

export const getters = {
  type: () => repository.type,
  package_id: () => repository.package_id,
  name: () => repository.name,
  attachment: () => repository.attachment,
};


export const mutation = {
  set(packageSelected) {
    repository.package_id = packageSelected.package_id;
    repository.name = packageSelected.name;
  },
};
